import { render, staticRenderFns } from "./PatentHistoryList.vue?vue&type=template&id=4e80d450&"
import script from "./PatentHistoryList.vue?vue&type=script&lang=js&"
export * from "./PatentHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./PatentHistoryList.vue?vue&type=style&index=0&id=4e80d450&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports